<template>
	<PageWithTitle>
		<template #title>
			<span>
				{{ $t( "slice-settings.layouts.UserProfileLayout.title" ) }}
			</span>
		</template>
	</PageWithTitle>
</template>

<script>
import { PageWithTitle } from "@teaming/common-ui";
import { foundation } from "@teaming/slice-engine";

export default {
	name: "UserProfileLayout",

	components: {
		PageWithTitle,
	},

	methods: {
		sendTelemetry() {
			// the 1 second pause is a hack until we can get an FSM (or similar)
			// around our amplitude module and queue up telemetry events to be
			// sent *after* we set the user profile so that events don't go w/o them
			setTimeout( () => {
				foundation().telemetry.user.viewedUserProfilePage();
			}, 1000 ); // eslint-disable-line no-magic-numbers
		},
	},

	mounted() {
		this.sendTelemetry();
	},
};
</script>

<style lang="scss">
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
}
</style>

<style lang="scss" scoped>
.user-settings-layout__header {
	width: 100%;
	border-bottom: 0.0625rem solid $user-settings-layout-header-border-color;
	display: flex;
	flex-direction: column;
}

.user-settings-layout__tab-container {
	@include auto-y-scroll();
	width: 100%;
	flex: 1;
	position: relative;
	display: flex;
	flex-direction: column;
}

.user-settings-layout__title-row {
	padding: 1.125rem 0 1.125rem 0;
	@include font-and-line-for(2);
	color: $user-settings-layout-title-font-color;
	overflow-y: hidden;

	@include for-size-and-larger('sm') {
		padding: 1.625rem 1rem 1.625rem 2rem;
	}
}

.user-settings-layout__title-position {
	position: relative;
}

.user-settings-layout__title-layout {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	flex: 1;

	@include for-size-and-larger('md') {
		gap: 0.5rem;
		justify-content: flex-start;
	}

	@include for-size('xs') {
		margin-left: 2.5rem;
	}
}

.user-settings-layout__title-text {
	font-weight: bold;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	@include font-and-line-for(1);

	@include for-size('sm') {
		@include font-and-line-for(2);
	}
}

.user-settings-layout__mobile-menu-icon {
	margin: 0;
	padding: 0;

	position: absolute;
	top: 0;
	left: 0;

	@include for-size('md') {
		display: none;
	}
}

</style>
